import { render, staticRenderFns } from "./transcriptForm.vue?vue&type=template&id=7acc6c23&scoped=true&"
import script from "./transcriptForm.vue?vue&type=script&lang=js&"
export * from "./transcriptForm.vue?vue&type=script&lang=js&"
import style0 from "./transcriptForm.vue?vue&type=style&index=0&id=7acc6c23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acc6c23",
  null
  
)

export default component.exports